import { createStyles } from "@material-ui/core";

export const styles = createStyles({
  content: {
    marginLeft: 320
  }
});